import { STATE_ABBREVIATION, type StateAbbreviation } from "@/enums/states";

type BoardRouteSlug = Lowercase<string>;

export const ADVERTISED_DISCOVER_BOARDS = {
  [STATE_ABBREVIATION.ARKANSAS]: "arkansas",
  [STATE_ABBREVIATION.INDIANA]: "indiana",
  [STATE_ABBREVIATION.MISSOURI]: "missouri",
  [STATE_ABBREVIATION.OKLAHOMA]: "oklahoma",
} as const satisfies Partial<Record<StateAbbreviation, BoardRouteSlug>>;

export type AdvertisedDiscoverBoard = keyof typeof ADVERTISED_DISCOVER_BOARDS;

export type AdvertisedBoardRoute =
  (typeof ADVERTISED_DISCOVER_BOARDS)[AdvertisedDiscoverBoard];

/** Temporary, and expected to empty out: once it does, delete the wall with it. */
export const DEPRECATED_DISCOVER_BOARDS = {
  [STATE_ABBREVIATION.TENNESSEE]: "tennessee",
} as const satisfies Partial<
  Record<Exclude<StateAbbreviation, AdvertisedDiscoverBoard>, BoardRouteSlug>
>;

export type DeprecatedDiscoverBoard = keyof typeof DEPRECATED_DISCOVER_BOARDS;

export type DeprecatedBoardRoute =
  (typeof DEPRECATED_DISCOVER_BOARDS)[DeprecatedDiscoverBoard];

export const DISCOVER_BOARDS = {
  ...ADVERTISED_DISCOVER_BOARDS,
  ...DEPRECATED_DISCOVER_BOARDS,
} as const;

export type DiscoverBoardState = keyof typeof DISCOVER_BOARDS;

export const ALL_STATES_BOARD_ROUTE = "all";

export type DiscoverBoardRoute =
  | (typeof DISCOVER_BOARDS)[DiscoverBoardState]
  | typeof ALL_STATES_BOARD_ROUTE;

export const advertisedDiscoverBoardStates = Object.keys(
  ADVERTISED_DISCOVER_BOARDS,
) as AdvertisedDiscoverBoard[];

export const deprecatedDiscoverBoardStates = Object.keys(
  DEPRECATED_DISCOVER_BOARDS,
) as DeprecatedDiscoverBoard[];

export const isDeprecatedDiscoverBoard = (
  state: StateAbbreviation,
): state is DeprecatedDiscoverBoard => state in DEPRECATED_DISCOVER_BOARDS;

// Takes a bare string: getDiscoverBoardRoute normalises untrusted input.
const isDiscoverBoardState = (state: string): state is DiscoverBoardState =>
  state in DISCOVER_BOARDS;

export const getDiscoverBoardRoute = (state: string): DiscoverBoardRoute => {
  const abbreviation = state.trim().toUpperCase();

  if (isDiscoverBoardState(abbreviation)) {
    return DISCOVER_BOARDS[abbreviation];
  }

  return ALL_STATES_BOARD_ROUTE;
};
